import React from 'react';
import PropTypes from 'prop-types';
import {
  LoanStatusSC,
  SoldSC,
  IconWrapper,
  SoldText,
  DetailWrapper,
  ValueText,
  SoldTextWhite,
} from './loan-status.styled';
import { FormattedHTMLMessage } from 'react-intl';
import { ReactComponent as SoldIcon } from '../../../assets/img/svg/guarantee.svg';
import { ReactComponent as ProgressIcon } from '../../../assets/img/svg/guarantee-2.svg';
import { ReactComponent as AuctionIcon } from '../../../assets/img/svg/auction.svg';
import dlt from '../../../utils/default-lang';
import numeral from 'numeral';

const LoanStatus = ({ offerStatus, isTransferred, offer, investor }) => {
  function getStatus() {
    const status = isTransferred ? 'is-transferred' : offerStatus;

    switch (status) {
      case 'offered-automatic':
        return (
          <SoldSC>
            <IconWrapper>
              <ProgressIcon />
            </IconWrapper>
            <SoldText className="bold">
              <FormattedHTMLMessage
                id={`investor_loan_detail_${status}`}
                defaultMessage={dlt[`investor_loan_detail_${status}`]}
              />
            </SoldText>
          </SoldSC>
        );
      case 'offered-manual':
        return (
          <>
            <SoldSC>
              <IconWrapper>
                <AuctionIcon />
              </IconWrapper>
              <div>
                <SoldText className="bold">
                  <FormattedHTMLMessage
                    id="investor_loan_detail_offered-manual"
                    defaultMessage={dlt['investor_loan_detail_offered-manual']}
                  />
                </SoldText>
                <ValueText>{numeral(Number(offer?.price)).format('0,00.00')} €</ValueText>
              </div>
            </SoldSC>
            <DetailWrapper>
              <SoldText>
                <FormattedHTMLMessage
                  id="investor_loan_detail_sold-manual_offered"
                  defaultMessage={dlt[`investor_loan_detail_sold-manual_offered`]}
                />{' '}
                <SoldTextWhite> {numeral(Number(offer?.value)).format('0,00.00')} €</SoldTextWhite>{' '}
                z {numeral(Number(investor?.totalTillEnd[9])).format('0,00.00')} €
              </SoldText>
            </DetailWrapper>
          </>
        );
      case 'sold-manual':
        return (
          <>
            <SoldSC>
              <IconWrapper>
                <SoldIcon />
              </IconWrapper>
              <div>
                <SoldText className="bold">
                  <FormattedHTMLMessage
                    id="investor_loan_detail_sold-manual"
                    defaultMessage={dlt['investor_loan_detail_sold-manual']}
                  />
                </SoldText>
                <ValueText sold>{numeral(Number(offer?.sold_for)).format('0,00.00')} €</ValueText>
              </div>
            </SoldSC>
            <DetailWrapper>
              <SoldText>
                <FormattedHTMLMessage
                  id="investor_loan_detail_sold-manual_offered"
                  defaultMessage={dlt[`investor_loan_detail_sold-manual_offered`]}
                />{' '}
                <SoldTextWhite> {numeral(Number(offer?.value)).format('0,00.00')} €</SoldTextWhite>
              </SoldText>
            </DetailWrapper>
          </>
        );
      case 'sold-automatic':
        return (
          <SoldSC>
            <IconWrapper>
              <SoldIcon />
            </IconWrapper>
            <SoldText className="bold">
              <FormattedHTMLMessage
                id="investor_loan_detail_sold-automatic"
                defaultMessage={dlt['investor_loan_detail_sold-automatic']}
              />
            </SoldText>
          </SoldSC>
        );
      case 'sold-gf':
        return (
          <SoldSC>
            <IconWrapper>
              <SoldIcon />
            </IconWrapper>
            <SoldText className="bold">
              <FormattedHTMLMessage
                id={`investor_loan_detail_${status}`}
                defaultMessage={dlt[`investor_loan_detail_${status}`]}
              />
            </SoldText>
          </SoldSC>
        );
      case 'is-transferred':
        return (
          <SoldSC>
            <IconWrapper>
              <SoldIcon />
            </IconWrapper>
            <SoldText className="bold">
              <FormattedHTMLMessage
                id={`investor_loan_detail_${status}`}
                defaultMessage={dlt[`investor_loan_detail_${status}`]}
              />
            </SoldText>
          </SoldSC>
        );
      default:
        return null;
    }
  }

  return <LoanStatusSC>{getStatus()}</LoanStatusSC>;
};

LoanStatus.propTypes = {
  offerStatus: PropTypes.oneOf([
    'offered-automatic',
    'sold-automatic',
    'offered-manual',
    'sold-manual',
    'sold-gf',
  ]),
  isTransferred: PropTypes.bool,
  offer: PropTypes.shape({
    price: PropTypes.number,
    value: PropTypes.number,
  }),
  investor: PropTypes.shape({
    totalTillEnd: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default LoanStatus;
